import { render, staticRenderFns } from "./FormOptionDetailsCollapse.vue?vue&type=template&id=30e1b408&scoped=true&"
import script from "./form-option-details-collapse.js?vue&type=script&lang=js&"
export * from "./form-option-details-collapse.js?vue&type=script&lang=js&"
import style0 from "./form-option-details-collapse.scss?vue&type=style&index=0&id=30e1b408&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e1b408",
  null
  
)

export default component.exports